module.exports = __webpack_public_path__ + "static/media/Maya LT.02e1af17.png";